<template>
  <v-card>
    <v-card-title
      v-bind:style="{
        color: getQuestionTypeColor(0)
      }"
    >
      <v-icon class="mr-2" :color="getQuestionTypeColor(0)">
        {{ getQuestionTypeIcon(0) }}
      </v-icon>
      Survey Intro
    </v-card-title>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="12">
          <v-text-field
            hide-details
            v-model="survey.title"
            label="Survey Title"
            outlined
            maxlength="100"
            :rules="[$rules.required]"
            required
          >
          </v-text-field>
        </v-col>
        <v-col cols="12">
          <v-textarea
            hide-details
            v-model="survey.description"
            outlined
            label="Description"
            :rows="5"
            :rules="[$rules.required]"
            required
          >
          </v-textarea>
        </v-col>
        <v-col cols="12">
          <v-switch
            hide-details
            class="ma-0 pa-0"
            v-model="survey.isAnonymous"
            label="Is this survey anonymous?"
          >
          </v-switch>
        </v-col>
        <v-col cols="12">
          <v-select
            hide-details
            v-model="linkTo"
            :items="survey_link_list"
            outlined
            label="Category"
            item-text="name"
            item-value="id"
          >
          </v-select>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import questionTypes from "@/helpers/mixins/questionTypes";
export default {
  name: "SurveyOverviewForm",
  components: {},
  mixins: [questionTypes],
  data: () => ({
    valid: false,
    saving: false
  }),
  computed: {
    linkTo: {
      get: function() {
        if (this.survey.mission) {
          return "mission";
        }
        return this.survey.companyCoreValueId;
      },
      set: function(val) {
        this.survey.mission = false;
        this.survey.companyCoreValueId = null;
        if (val == "mission") {
          this.survey.mission = true;
        } else if (val != "") {
          this.survey.companyCoreValueId = val;
        }
      }
    },
    ...mapGetters({
      survey: "survey/edit_survey",
      survey_link_list: "company/survey_link_list"
    })
  },
  created() {},
  methods: {}
};
</script>
